import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-onyx px-4 pt-24 text-center">
      <Seo title="Checkout Cancelled" description="Your mellowjmedia checkout was cancelled. Your selected photos remain available." />
      <div className="max-w-xl border border-white/10 bg-carbon p-10">
        <p className="font-mono text-xs uppercase tracking-[0.42em] text-gold">Checkout paused</p>
        <h1 className="mt-5 font-display text-5xl font-light text-white">No payment was taken.</h1>
        <p className="mt-4 text-sm leading-7 text-zinc-500">Your selection remains in the cart, so you can return to secure checkout whenever you are ready.</p>
        <Link data-testid="cancel-return-events-button" to="/events" className="mt-8 inline-flex bg-gold px-6 py-3 font-mono text-xs uppercase tracking-[0.22em] text-onyx hover:bg-titanium">Return to events</Link>
      </div>
    </div>
  );
}
